<template>
  <div
    class="team-calendar-event-row d-flex flex-column mb-3 pt-4 pb-4 pt-sm-4 pb-sm-4"
  >
    <div
      class="event-container d-flex flex-row"
      style="border: 0px solid purple;"
    >
      <!-- column 1 -->
      <div
        class="d-none d-sm-flex flex-sm-row align-sm-center"
        style="border: 0px solid red;"
        @click="toggleExpand"
      >
        <v-btn
          :ripple="false"
          class="ml-2 mr-0 mt-1 ml-sm-3 mr-sm-2"
          icon
          plain
          rounded
        >
          <v-icon color="grey" medium
            >{{ expanded ? "mdi-chevron-down" : "mdi-chevron-right" }}
          </v-icon>
        </v-btn>

        <div
          class="event-date-badge hide-mobile"
          v-bind:style="{
            backgroundColor: event.details.eventType.color,
            color: event.details.eventType.textColor,
            borderColor: event.details.eventType.borderColor
          }"
        >
          <div class="event-date-day-of-week">
            {{ eventStartDayOfWeek(event) }}
          </div>
          <div class="event-date-day-of-month">
            {{ eventStartDayOfMonth(event) }}
          </div>
        </div>
      </div>

      <!-- column 2 -->
      <div
        class="flex-grow-1 flex-column align-center pl-4 pl-sm-6"
        style="font-size: 16px; line-height: 18px; border: 0px solid green;"
      >
        <div
          class="event-type mt-1 mb-1"
          v-bind:style="{
            color: event.details.eventType.color
          }"
        >
          {{ event.details.eventType.name }}
        </div>
        <div class="event-name d-flex flex-row align-center">
          <span>
            {{ event.details.name }}
          </span>
          <span v-if="!isSelectedTeamsEvent(event)" class="team-badge">
            {{ event.details.orgUnit.name }}
          </span>
        </div>

        <div
          class="d-flex flex-column"
          style="border: 0px solid deeppink; margin-top: 5px; padding-top: 5px;"
        >
          <div
            class="event-date-time d-flex flex-row mt-2 mt-sm-0 mr-4"
            style="border: 0px solid orange;"
          >
            <div class="d-flex flex-row align-start flex-sm-row">
              <v-icon
                class="mr-5 mr-sm-2"
                color="black"
                style="font-size: 22px;"
              >
                mdi-clock-outline
              </v-icon>
              <div>
                {{ eventStartDate(event) }}, {{ eventStartTime(event) }}-{{
                  eventEndTime(event)
                }}
                <small class="grey--text">
                  {{ event.details.timezone }}
                </small>
              </div>
            </div>
          </div>

          <div
            class="event-location d-flex flex-row align-start mt-2"
            style="border: 0px solid orange;"
          >
            <v-icon class="mr-5 mr-sm-2" color="black" style="font-size: 22px;"
              >mdi-map-marker-outline
            </v-icon>
            <div class="d-flex flex-column align-left">
              <a
                v-if="
                  !isGlobalVenue(event.details.venue) &&
                    event.details.venue.mapUrl
                "
                :href="event.details.venue.mapUrl"
                target="_blank"
              >
                {{ event.details.venue.name }}
                <span v-if="event.details.field">{{
                  event.details.field
                }}</span>
              </a>
              <div v-else>
                {{ event.details.venue.name }}
                <span v-if="event.details.field">{{
                  event.details.field
                }}</span>
              </div>
            </div>
          </div>

          <div
            class="event-availability-summary d-flex d-sm-none flex-row mt-4"
            style="border: 0px solid orange;"
            @click="toggleExpand"
          >
            <EventAvailabilitySummary
              :player-invites-no="playerInvitesNo"
              :player-invites-unknown="playerInvitesUnknown"
              :player-invites-yes="playerInvitesYes"
            />
          </div>
        </div>
      </div>

      <!-- column 3 -->
      <div
        class="d-none d-sm-flex flex-row align-center"
        style="border: 0px solid blue; cursor:pointer;"
        @click="toggleExpand"
      >
        <EventAvailabilitySummary
          :player-invites-no="playerInvitesNo"
          :player-invites-unknown="playerInvitesUnknown"
          :player-invites-yes="playerInvitesYes"
        />
      </div>

      <!-- column 4 -->
      <div
        class="d-flex flex-column align-center justify-space-between justify-sm-center pt-1 pr-2 pt-sm-0 pr-sm-0"
        style="border: 0px solid purple;"
      >
        <div class="event-ellipsis ma-0 mx-sm-5 ">
          <v-menu>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                :ripple="false"
                icon
                plain
                rounded
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="black">mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item @click="openEventModal(event.id)">
                <v-list-item-icon>
                  <v-icon color="grey" small>mdi-pencil-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  Edit Details
                </v-list-item-content>
              </v-list-item>

              <v-list-item @click="showEmail = true">
                <v-list-item-icon>
                  <v-icon color="grey" small>mdi-email-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  Send Email
                </v-list-item-content>
              </v-list-item>

              <v-list-item @click="showCloneEvent">
                <v-list-item-icon>
                  <v-icon small>mdi-content-copy</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Clone Event</v-list-item-title>
                </v-list-item-content>
              </v-list-item>

              <v-list-item
                v-if="selectedOrg.orgAdmin"
                @click="showCloneEventToTeam"
              >
                <v-list-item-icon>
                  <v-icon small>mdi-content-copy</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Clone to Teams</v-list-item-title>
                </v-list-item-content>
              </v-list-item>

              <v-list-item @click="requestDelete">
                <v-list-item-icon>
                  <v-icon small>mdi-delete</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Delete Event</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>

        <v-btn
          :ripple="false"
          class="d-inline d-sm-none"
          icon
          plain
          rounded
          small
          @click="toggleExpand"
        >
          <v-icon color="black" medium>{{
            expanded ? "mdi-chevron-up" : "mdi-chevron-down"
          }}</v-icon>
        </v-btn>
      </div>
    </div>
    <div>
      <div v-if="expanded">
        <v-divider class="my-4" style="opacity: .5;" />
        <div class="pl-4 pl-sm-12">
          <EventRowAvailability
            :player-invites="playerInvitesYes"
            icon="mdi-check-bold"
            icon-color="green"
            label="Going"
            token-color="rgb(203,248,226)"
            @removePlayerInvite="removePlayerInvite"
          />

          <EventRowAvailability
            :player-invites="playerInvitesNo"
            icon="mdi-close"
            icon-color="red"
            label="Not Going"
            token-color="rgb(252,221,221)"
            @removePlayerInvite="removePlayerInvite"
          />

          <EventRowAvailability
            :player-invites="playerInvitesUnknown"
            icon="mdi-clock-outline"
            icon-color="gray"
            label="No Response"
            token-color="rgb(233,241,252);"
            @removePlayerInvite="removePlayerInvite"
          />
          <EventRowNotInvitedAvailability
            :event="event"
            :loading="retrievingNotInvitedPlayers"
            :players="notInvitedPlayers"
            icon="mdi-clock-outline"
            icon-color="gray"
            label="Not Invited"
            token-color="rgb(233,241,252);"
            @removePlayer="removePlayer"
            @removeAllPlayers="removeAllPlayers"
          />
        </div>

        <v-divider class="my-4" style="opacity: .5;" />
        <div
          style="text-align: center; color: rgba(0,0,0,.5); font-style: italic; font-size: 11px;"
        >
          Tap a player to add, remove, or change their availability.
        </div>
      </div>
    </div>

    <CommonDialog :is-dialog-opened="showCloneEventModal" width="500px">
      <CloneEventModal
        :event="event"
        :teamId="teamId"
        @cancel="showCloneEvent"
      />
    </CommonDialog>
    <CommonDialog :is-dialog-opened="showCloneEventToTeamModal" width="500px">
      <CloneEventToTeamModal
        @cancel="showCloneEventToTeam"
        :teamId="teamId"
        :event="event"
      />
    </CommonDialog>
    <CommonDialog :is-dialog-opened="showConfirm" width="500px">
      <EllipsisConfirmationModal
        @cancel="showConfirm = !showConfirm"
        @confirm="deleteEvent"
      >
        Are you sure you want to delete {{ event.name }}?
      </EllipsisConfirmationModal>
    </CommonDialog>
    <CommonDialog :is-dialog-opened="showDeleteEventFailed" width="500px">
      <div style="background-color: white; max-width: 500px;">
        <div class="pa-5 body-1">
          {{ deleteEventFailedMessage }}
          <div
            v-for="registration in registrationsIncludingEvent"
            :key="registrationsIncludingEvent.indexOf(registration)"
            class="pt-2 font-weight-bold"
          >
            {{ registration }}
          </div>
        </div>
        <v-row class="pa-2" style="max-width: 100%;">
          <v-spacer />
          <CommonButton
            color="default"
            label="ok"
            width="100"
            @handleClick="showDeleteEventFailed = false"
          />
        </v-row>
      </div>
    </CommonDialog>
    <i-frame-modal
      :event-ids="[event.id]"
      :fullscreen="false"
      :height="800"
      :show="showEmail"
      :url="'/email-event/' + event.id + '?hideNav=true'"
      :width="1200"
      title="Email"
      @close="showEmail = false"
    />
  </div>
</template>
<script>
import Vue from "vue";
import moment from "moment";
import { bus } from "../../main";
import { cloneEvent, deleteEvent } from "../../helpers/api";
import EventRowAvailability from "@/components/TeamCalendar/EventRowAvailability";
import EventRowNotInvitedAvailability from "@/components/TeamCalendar/EventRowNotInvitedAvailability";
import CommonDialog from "../../views/academy/common/dialog/CommonDialog";
import EllipsisConfirmationModal from "../Teams/EllipsisConfirmationModal";
import CloneEventModal from "@/components/TeamCalendar/CloneEventModal.vue";
import CloneEventToTeamModal from "@/components/TeamCalendar/CloneEventToTeamModal.vue";
import { mapGetters } from "vuex";
import GetterTypes from "@/store/GetterTypes";
import { getNotInvitedPlayers } from "@/helpers/api";
import IFrameModal from "@/components/common/iFrameModal";
import EventAvailabilitySummary from "@/components/TeamCalendar/EventAvailabilitySummary";
import CommonButton from "@/views/academy/common/CommonButton.vue";

export default Vue.extend({
  name: "TeamCalendarEventRow",
  components: {
    CommonButton,
    EventAvailabilitySummary,
    IFrameModal,
    EventRowAvailability,
    EventRowNotInvitedAvailability,
    CommonDialog,
    EllipsisConfirmationModal,
    CloneEventModal,
    CloneEventToTeamModal
  },
  props: {
    event: {
      type: Object
    },
    teamId: {
      type: String
    }
  },
  data() {
    return {
      expanded: false,
      showConfirm: false,
      showCloneEventModal: false,
      showCloneEventToTeamModal: false,
      retrievingNotInvitedPlayers: false,
      showEmail: false,
      notInvitedPlayers: [],
      showDeleteEventFailed: false,
      deleteEventFailedMessage: "",
      registrationsIncludingEvent: []
    };
  },
  methods: {
    removePlayer(id) {
      this.notInvitedPlayers = this.notInvitedPlayers.filter(p => p.id != id);
    },
    removeAllPlayers() {
      this.notInvitedPlayers = [];
    },
    isSelectedTeamsEvent(event) {
      return event.details.orgUnit.id === this.teamId;
    },
    eventStartDate(event) {
      return moment(event.details.start).format(`dddd, MMMM D`);
    },
    eventStartMonth(event) {
      return moment(event.details.start).format(`MMM `);
    },
    eventStartDayOfMonth(event) {
      return moment(event.details.start).format(`D`);
    },
    eventStartDayOfWeek(event) {
      return moment(event.details.start).format(`ddd`);
    },
    eventStartTime(event) {
      return moment(event.details.start).format(`h:mma`);
    },
    eventEndTime(event) {
      return moment(event.details.end).format(`h:mma`);
    },
    toggleExpand() {
      this.expanded = !this.expanded;
    },
    showCloneEvent() {
      this.showCloneEventModal = !this.showCloneEventModal;
    },
    showCloneEventToTeam() {
      this.showCloneEventToTeamModal = !this.showCloneEventToTeamModal;
    },
    cloneEvent() {
      cloneEvent(this.teamId, this.event.id).then(() => {
        bus.$emit("successSnack", "Event Cloned!");
      });
    },
    requestDelete() {
      this.showConfirm = true;
    },
    deleteEvent() {
      this.showConfirm = false;
      bus.$emit("loadingOn");
      deleteEvent(this.event.id)
        .then(res => res.data)
        .then(res => {
          if (res.success === false && res.error.includes("registration")) {
            this.registrationsIncludingEvent = res.registrations;
            this.deleteEventFailed(res.error);
          } else {
            bus.$emit("refetchTeam");
            bus.$emit("loadingOff");
            bus.$emit("successSnack", this.event.name + " was deleted.");
          }
        })
        .catch(e => {
          bus.$emit("loadingOff");
          bus.$emit("errorSnack", "An error occurred: " + e.toString());
        });
    },
    playerInvitesByStatus(statusName) {
      return (
        this.alphabetizedPlayerInvites.filter(
          playerInvite => playerInvite.status.name === statusName
        ) || []
      );
    },
    removePlayerInvite(invite) {
      const index = this.event.details.playerInvites.findIndex(
        playerInvite => playerInvite.id === invite.id
      );
      const removed =
        index > -1
          ? this.event.details.playerInvites.splice(index, 1)[0]
          : null;
      this.notInvitedPlayers.push(invite.player);
      return removed;
    },
    getRegistrationUrl() {
      return `${window.location.origin}/o/${this.teamId}/register`;
    },
    copyRegistrationVal() {
      navigator.clipboard.writeText(this.getRegistrationUrl());
      bus.$emit("successSnack", "Copied!");
    },
    async getNotInvitedPlayers() {
      this.retrievingNotInvitedPlayers = true;
      const resp = await getNotInvitedPlayers(this.event.id);
      if (resp.data.success) {
        this.notInvitedPlayers = resp.data.players;
        console.log(this.event);
      }
      this.retrievingNotInvitedPlayers = false;
    },
    openEventModal(id) {
      const callback = () => {
        bus.$emit("refetchTeam");
      };
      bus.$emit("loadIframe", {
        title: "",
        url: "/event/details/" + id + "?hideNav=true",
        callback: callback
      });
    },
    redirectToVenueEditor() {
      bus.$emit("loadIframe", {
        title: "",
        url: `/venue/edit/${this.event.details.venue.id}?selectedOrgUnit=${this.event.details.orgUnit.id}&hideNav=true`
      });
    },
    redirectToUrl(url) {
      window.location.href = url;
    },
    deleteEventFailed(message) {
      this.showDeleteEventFailed = true;
      this.deleteEventFailedMessage = message;
    }
  },
  computed: {
    alphabetizedPlayerInvites() {
      const alphabetizedPlayerInvites = this.event.details.playerInvites;
      return alphabetizedPlayerInvites.sort((a, b) =>
        a.player.name > b.player.name ? -1 : 1
      );
    },
    allInvites() {
      const statuses = [
        { text: "Yes", icon: "mdi-check-bold", iconColor: "green" },
        { text: "No", icon: "mdi-cancel", iconColor: "red" },
        { text: "Unknown", icon: "mdi-help", iconColor: "grey" }
      ];
      const arr = [];
      statuses.forEach(status => {
        const inviteObj = {
          invites: this.playerInvitesByStatus(status.text),
          icon: status.icon,
          iconColor: status.iconColor
        };
        arr.push(inviteObj);
      });
      return arr;
    },
    canEditVenues() {
      return this.user.roles.find(role => role === "ROLE_ORG_ADMIN");
    },
    isGlobalVenue() {
      return venue => {
        const globalVenues = ["[online]", "[tbd]", "[no venue]"];
        const name = venue.name.toLowerCase();
        return globalVenues.find(v => v === name);
      };
    },
    playerInvitesYes() {
      return this.playerInvitesByStatus("Yes");
    },
    playerInvitesNo() {
      return this.playerInvitesByStatus("No");
    },
    playerInvitesUnknown() {
      return this.playerInvitesByStatus("Unknown");
    },
    ...mapGetters({
      user: GetterTypes.GET_USER,
      selectedOrg: GetterTypes.GET_ORGANIZATION
    })
  },
  watch: {
    expanded: {
      handler: function(val) {
        if (val) {
          this.getNotInvitedPlayers();
        }
      }
    }
  }
});
</script>
<style>
.registration-url {
  background-color: #edf5fe;
  max-width: 500px;
  font-size: 10px;
}

.registration-url .v-icon {
  font-size: 14px;
}

.team-calendar-event-row {
  border-bottom: 1px solid #ddd;
}

.team-calendar-event-row:hover {
  --box-shadow: 0 12px 20px 0 rgba(30, 36, 51, 0.1) !important;
}

.team-calendar-event-row .event-info {
  line-height: 1.4;
}

.team-calendar-event-row .event-date-badge {
  width: 65px;
  height: 65px;
  flex-shrink: 0;
  border-radius: 10px;
  padding: 10px;
  text-align: center;
  line-height: 1.25;
}

.team-calendar-event-row .event-date-badge .event-date-day-of-week {
  font-size: 13px;
  text-transform: uppercase;
}

.team-calendar-event-row .event-date-badge .event-date-day-of-month {
  font-size: 26px;
}

.team-calendar-event-row .event-type {
  font-size: 14px;
  font-weight: 500;
  text-transform: uppercase;
  margin-top: -6px;
}

.team-calendar-event-row .event-name {
  font-size: 22px;
  font-weight: 500;
  color: black;
}

.team-calendar-event-row .event-date-time {
  color: black;
}

.team-calendar-event-row .event-date-time small {
  font-size: 12px;
  font-weight: 500;
  text-transform: uppercase;
}

.team-calendar-event-row .event-location a {
  text-decoration: none !important;
}

.team-calendar-event-row .event-location {
}

.team-calendar-event-row .event-availability {
  font-size: 14px;
  font-weight: 500;
  padding: 5px 15px;
  cursor: pointer;
}

.team-calendar-event-row .team-badge {
  border-radius: 4px;
  background-color: #eaeaea;
  color: #666666;
  font-size: 11px;
  padding: 1px 8px;
  margin-left: 5px;
}

.team-calendar-event-row .event-action-link {
  text-decoration: none;
}

.team-calendar-event-row .mobile-action-buttons .v-btn {
  display: flex;
  flex: 1;
  border-right: 1px solid #ddd;
  padding: 30px !important;
}

.team-calendar-event-row .mobile-action-buttons .v-btn .v-btn__content {
  display: flex;
  flex-direction: column;
}
.team-calendar-event-row .mobile-action-buttons .v-btn .v-icon {
  display: flex;
  width: 32px;
  height: 32px;
}

.details-container {
  margin-right: auto;
}

.expansion-container {
  padding-left: 64px;
}

.expansion-items {
  margin-left: 64px;
}

.registration-icon {
  display: none !important;
}

@media (max-width: 662px) {
  .event-name {
    max-height: 55px;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .registration-url {
    display: none;
  }

  .registration-icon {
    display: inline-block !important;
    margin-left: 20px;
  }

  .details-container {
    margin-left: 0px;
  }

  .expansion-container {
    margin-top: 14px;
    padding-left: 0px;
  }

  .expansion-items {
    margin-left: 0px;
  }

  .event-sub-info {
  }

  .event-location {
    width: 100%;
    margin-left: 0px !important;
  }

  .team-calendar-event-row .event-availability {
    margin-right: 0px;
  }

  .event-ellipsis {
  }
}
</style>
